export const translations = {
  en: {
    // Navigation
    home: "Home",
    cv: "CV",
    works: "Works",

    // Company Info
    companyName: "Amem Company for General Contracting",
    specialty: "Specialty",
    specialties: {
      construction: "Construction (First Class)",
      electric: "Electric (First Class)",
      mechanical: "Mechanical (First Class)"
    },
    founded: "Founded",
    foundedYear: "2003",

    // Contact
    contact: "Contact Us",
    phone: "Phone",
    phoneNumber: "07807287788",
    location: "Location",
    locationText: "Babil Governorate, Iraq",
    director: "CEO",
    directorName: "Dr. Eng. Naseer Ali Al-Husseini",

    // About
    about: "About Us",
    aboutText: "Amem Company for General Contracting is a class-one contracting company in construction, electric and mechanical specialties, with a capital of seven billion Iraqi Dinars. The company's main branch is located in Babylon.",

    // Assets
    assets: "Company Assets",
    assetsList: [
      "Asphalt plant with a capacity of 140 tons per hour in Holy Karbala",
      "Ready-mix concrete plant with a capacity of 135 m³ per hour in Babil Governorate"
    ],

    // CV Page
    downloadCV: "Download CV",
    cvDescription: "Download our complete company profile and portfolio",

    // Works Page
    ourWorks: "Our Works",
    timeline: "Project Timeline",
    cost: "Cost",
    dinars: "Iraqi Dinars",
    dollars: "US Dollars",

    // Footer
    copyright: "© 2025 Amem Company for General Contracting. All rights reserved.",
    capital: "Capital",
    capitalAmount: "7 Billion Iraqi Dinars"
  },

  ar: {
    // Navigation
    home: "الرئيسية",
    cv: "السيرة الذاتية",
    works: "الأعمال",

    // Company Info
    companyName: "شركة أميم للمقاولات العامة",
    specialty: "الاختصاص",
    specialties: {
      construction: "إنشائية (درجة أولى)",
      electric: "كهربائية (درجة أولى)",
      mechanical: "ميكانيكية (درجة أولى)"
    },
    founded: "تأسست عام",
    foundedYear: "2003",

    // Contact
    contact: "اتصل بنا",
    phone: "الهاتف",
    phoneNumber: "07807287788",
    location: "الموقع",
    locationText: "محافظة بابل، العراق",
    director: "المدير المفوض",
    directorName: "المهندس الاستشاري  د. نصير علي الحسيني",

    // About
    about: "من نحن",
    aboutText: "شركة أميم للمقاولات العامة هي شركة تصنيف أول في الاختصاص الانشائي والكهربائي والميكانيكي تتمتع برأس مال قدره سبعة مليارات دينار عراقي. يقع الفرع الرئيسي للشركة في حي الاساتذة، محافظة بابل، بالدار رقم (5056).",

    // Assets
    assets: "أصول الشركة",
    assetsList: [
      "معمل أسفلت بطاقة 140 طن في الساعة في كربلاء المقدسة",
      "معمل كونكريت جاهز بطاقة 135 م³ في الساعة في محافظة بابل"
    ],

    // CV Page
    downloadCV: "تحميل السيرة الذاتية",
    cvDescription: "قم بتحميل ملف الشركة الكامل ومحفظة الأعمال",

    // Works Page
    ourWorks: "أعمالنا",
    timeline: "الجدول الزمني للمشاريع",
    cost: "الكلفة",
    dinars: "دينار عراقي",
    dollars: "دولار أمريكي",

    // Footer
    copyright: "© 2025 شركة أميم للمقاولات العامة. جميع الحقوق محفوظة.",
    capital: "رأس المال",
    capitalAmount: "7 مليار دينار عراقي"
  }
};

export const worksData = {
  2001: {
    en: [
      { name: "Optical cable extension in Babil Governorate (Project 753)", cost: "14,000,000", currency: "dinars" }
    ],
    ar: [
      { name: "اعمال مشروع (753) مد الكيبل الضوئي في محافظة بابل", cost: "14,000,000", currency: "dinars" }
    ]
  },
  2002: {
    en: [
      { name: "Construction of fence (1.25 km) at Public Company for Construction Materials Trade", cost: "30,000,000", currency: "dinars" },
      { name: "Pouring concrete beams in Babil", cost: "33,000,000", currency: "dinars" },
      { name: "Construction of single warehouse in Karbala", cost: "44,000,000", currency: "dinars" }
    ],
    ar: [
      { name: "انشاء سياج طول (1.25) كم في الشركة العامة لتجارة المواد الانشائية في محافظة بابل", cost: "30,000,000", currency: "dinars" },
      { name: "صب العوارض الكونكريتية في بابل", cost: "33,000,000", currency: "dinars" },
      { name: "انشاء مخزن مفرد في كربلاء", cost: "44,000,000", currency: "dinars" }
    ]
  },
  2003: {
    en: [
      { name: "Construction of S.D.H. communication stations in Al-Qassam-Al-Hashimiyah District", cost: "11,000,000", currency: "dinars" },
      { name: "Construction of box girder bridge on Maddhatiyah-Shumali Road", cost: "93,750,000", currency: "dinars" }
    ],
    ar: [
      { name: "انشاء محطات (S.D.H.) خاصة بالاتصالات ناحية القسام-الهاشمية", cost: "11,000,000", currency: "dinars" },
      { name: "عمل قنطرة صندوقية على طريق المدحتية-الشوملي", cost: "93,750,000", currency: "dinars" }
    ]
  },
  2004: {
    en: [
      { name: "Paving streets of Al-Ghary neighborhood in Najaf (3 km)", cost: "200,000,000", currency: "dinars" },
      { name: "Maintenance of central medians for Hilla-Karbala road", cost: "11,840,000", currency: "dinars" }
    ],
    ar: [
      { name: "تبليط شوارع حي الغري في النجف الاشرف بطول 3 كم", cost: "200,000,000", currency: "dinars" },
      { name: "صيانة المانهولات الوسطية لطريق حلة - كربلاء", cost: "11,840,000", currency: "dinars" }
    ]
  },
  2006: {
    en: [
      { name: "Paving Hawa Al-Sham village road in Babil (9 km)", cost: "900,000,000", currency: "dinars" }
    ],
    ar: [
      { name: "تبليط طريق قرية هوى الشام في محافظة بابل بطول 9 كم", cost: "900,000,000", currency: "dinars" }
    ]
  },
  2007: {
    en: [
      { name: "Paving streets of Al-Karama neighborhood in Al-Hillah (8 km)", cost: "750,000,000", currency: "dinars" },
      { name: "Paving roads in Al-Jamiah neighborhood in Al-Hillah (1 km)", cost: "160,000,000", currency: "dinars" },
      { name: "Paving streets of military neighborhood (14 km) in Babil", cost: "2,260,000,000", currency: "dinars" },
      { name: "Paving streets of Mshimsh and Al-Owaisat villages (9 km) in Maddhatiyah District", cost: "1,300,000,000", currency: "dinars" }
    ],
    ar: [
      { name: "تبليط شوارع حي الكرامة في الحلة بطول 8 كم", cost: "750,000,000", currency: "dinars" },
      { name: "تبليط طرق في حي الجمعية في الحلة بطول 1 كم", cost: "160,000,000", currency: "dinars" },
      { name: "تبليط شوارع الحي العسكري بطول 14 كلم في محافظة بابل", cost: "2,260,000,000", currency: "dinars" },
      { name: "تبليط شوارع قرية مشيمش والعويسات بطول 9 كم في محافظة بابل ناحية المدحتية", cost: "1,300,000,000", currency: "dinars" }
    ]
  },
  2008: {
    en: [
      { name: "Paving Al-Ibrahimiya village road in Al-Hillah (2 km)", cost: "300,000,000", currency: "dinars" }
    ],
    ar: [
      { name: "تبليط طريق قرية الابراهيمية في الحلة بطول 2 كم", cost: "300,000,000", currency: "dinars" }
    ]
  },
  2010: {
    en: [
      { name: "Construction of main blood bank in Al-Hillah", cost: "2,000,000,000", currency: "dollars" },
      { name: "Construction of third phase of Meetham Al-Tammar Road in Karbala", cost: "23,000,000,000", currency: "dinars" }
    ],
    ar: [
      { name: "إنشاء مصرف دم رئيسي في الحلة", cost: "2,000,000,000", currency: "dollars" },
      { name: "انشاء طريق ميثم التمار المرحلة الثالثة في محافظة كربلاء", cost: "23,000,000,000", currency: "dinars" }
    ]
  },
  2013: {
    en: [
      { name: "Paving Ya Hussein Road (5 km) in Babil", cost: "650,000,000", currency: "dinars" }
    ],
    ar: [
      { name: "تبليط طريق يا حسين بطول 5 كم في محافظة بابل", cost: "650,000,000", currency: "dinars" }
    ]
  },
  2014: {
    en: [
      { name: "Construction of Al-Hawali Road in Babil, Al-Qasim District", cost: "4,500,000,000", currency: "dinars" },
      { name: "Paving Ya Hussein Road (20 km) two layers for Ain Al-Helwa Company and Talib Kurdi Rudhan, Karbala towards Baghdad", cost: "3,000,000,000", currency: "dinars" }
    ],
    ar: [
      { name: "انشاء طريق الحولي في محافظة بابل ناحية القاسم", cost: "4,500,000,000", currency: "dinars" },
      { name: "تبليط طريق يا حسين بطول 20 كم لصالح شركة عين الحلوة وطالب كردي روضان طبقتين، محافظة كربلاء باتجاه بغداد", cost: "3,000,000,000", currency: "dinars" }
    ]
  },
  2022: {
    en: [
      { name: "A building for suites in the city of Al-Za'ireen / Al-Hasan Al-Mujtaba - Najaf Road", cost: "7,000,000,000", currency: "dinars" },
      { name: "Construction of a sewage lifting station for G.C.I.T.G. - Greater Hilla Sewer Project", cost: "1,276,000", currency: "dollars" }
    ],
    ar: [
      { name: "بناية سويتات في مدينة الزائرين / الحسن المجتبى - طريق النجف", cost: "7,000,000,000", currency: "dinars" },
      { name: "إنشاء محطة رفع مجاري G.C.I.T.G. - خط مشروع مجاري الحلة الكبير", cost: "1,276,000", currency: "dollars" }
    ]
  }
};

export type Language = 'en' | 'ar';
export type Translations = typeof translations.en;
